import { Empty } from "antd";
import SelectAllCard from "../selectAll";
import DepositsCard from "../deposits";
import { useTranslation } from "react-i18next";

export default function DepositList({
  dataSource = [],
  handleSelectAll,
  handleMultiApproveOrReject,
  selectAllChecked,
  handleMultiDelete,
  handleCheckBoxChange,
  handleApproveOrReject,
  handleDelete,
}) {
  const { t } = useTranslation();
  return (
    <>
      {dataSource.length === 0 ? (
        <Empty description={t("common.no_records_found", {
              defaultValue: "No Records Found",
            })} />
      ) : (
        <div>
          <div>
            <SelectAllCard
              record={dataSource}
              handleSelectAll={handleSelectAll}
              handleMultiApproveOrReject={handleMultiApproveOrReject}
              selectAllChecked={selectAllChecked}
              handleMultiDelete={handleMultiDelete}
            />
          </div>
          <div>
            {dataSource.map((option, index) => (
              <DepositsCard
                record={option}
                handleCheckBoxChange={handleCheckBoxChange}
                handleApproveOrReject={handleApproveOrReject}
                handleDelete={handleDelete}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
}
